/**
 * Article pages (mobile): transparent over hero → solid over body content →
 * transparent again when footer-behind-header (footer covers viewport).
 * Same wt-header--transparent toggle as assets/logo-banner.js.
 *
 * Theme editor: script may re-evaluate on section:load — always destroy prior
 * instance before init so observers/listeners cannot stack.
 */
(function () {
  if (window.__amArticleHeader && typeof window.__amArticleHeader.destroy === 'function') {
    window.__amArticleHeader.destroy();
  }

  /* Match am-header-custom.css mobile fixed-header breakpoint (~1697). */
  var MOBILE_MQ = '(max-width: 768px)';
  var TRANSPARENT = 'wt-header--transparent';
  var mq = window.matchMedia(MOBILE_MQ);
  var header = null;
  var trigger = null;
  var observer = null;
  var bodyObserver = null;
  var resizeTimer = 0;
  var startedTransparent = false;
  var boundHeaderH = 0;
  var lastShouldHave = null;
  var applying = false;
  var destroyed = false;
  var listenersAttached = false;
  var bindCount = 0;

  function isArticlePage() {
    if (!document.body) return false;
    var list = document.body.classList;
    if (list.contains('template-article')) return true;
    for (var i = 0; i < list.length; i++) {
      if (list[i].indexOf('template-article-') === 0) return true;
    }
    return false;
  }

  if (!isArticlePage()) {
    window.__amArticleHeader = { destroy: function () {} };
    return;
  }

  function getHeader() {
    return document.querySelector('#header.wt-header--amateur-custom');
  }

  function getTrigger() {
    return document.querySelector('.main-article__content');
  }

  function isMenuOpen() {
    var h = header || getHeader();
    return (
      document.body.classList.contains('menu-open') ||
      document.body.classList.contains('menu-drawer-overlay-on') ||
      document.body.classList.contains('am-header-menu-closing') ||
      !!(h && h.classList.contains('am-logo-scroll--menu-open')) ||
      !!(h && h.classList.contains('am-logo-scroll--menu-open-frozen'))
    );
  }

  function isFooterBehind() {
    return document.body.classList.contains('footer-behind-header');
  }

  function headerHeight() {
    var h = header || getHeader();
    if (!h) return 0;
    return Math.round(h.getBoundingClientRect().height) || 0;
  }

  /** Idempotent — skip DOM writes when already in the desired state. */
  function setTransparent(on) {
    if (!header || destroyed) return;
    var shouldHave;
    if (isMenuOpen()) {
      shouldHave = false;
    } else if (isFooterBehind()) {
      /* Footer covering viewport: drop solid bar so footer shows through. */
      shouldHave = startedTransparent;
    } else {
      shouldHave = !!on && startedTransparent;
    }
    if (lastShouldHave === shouldHave && header.classList.contains(TRANSPARENT) === shouldHave) {
      return;
    }
    lastShouldHave = shouldHave;
    if (shouldHave) {
      header.classList.add(TRANSPARENT);
    } else {
      header.classList.remove(TRANSPARENT);
    }
  }

  function applyFromEntry(entry) {
    if (destroyed || applying || !header || !mq.matches) return;
    applying = true;
    try {
      if (isMenuOpen()) {
        setTransparent(false);
        return;
      }
      if (isFooterBehind()) {
        setTransparent(true);
        return;
      }
      var h = boundHeaderH || headerHeight();
      if (!h) return;
      var solid = entry.boundingClientRect.top <= h;
      /* Do not rebind / recreate the observer here. */
      setTransparent(!solid);
    } finally {
      applying = false;
    }
  }

  function disconnectObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function disconnectBodyObserver() {
    if (bodyObserver) {
      bodyObserver.disconnect();
      bodyObserver = null;
    }
  }

  function bindObserver() {
    if (destroyed) return;
    bindCount += 1;
    if (bindCount > 30) return;

    disconnectObserver();
    header = getHeader();
    trigger = getTrigger();

    if (!header || !trigger) return;

    if (!mq.matches) {
      if (startedTransparent && !isMenuOpen()) {
        lastShouldHave = null;
        setTransparent(true);
      }
      return;
    }

    var h = headerHeight();
    if (!h) return;

    boundHeaderH = h;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          applyFromEntry(entry);
        });
      },
      {
        root: null,
        rootMargin: '-' + h + 'px 0px 0px 0px',
        threshold: 0,
      }
    );
    observer.observe(trigger);
    applyFromEntry({ boundingClientRect: trigger.getBoundingClientRect() });
  }

  function onMqChange() {
    lastShouldHave = null;
    bindObserver();
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (destroyed) return;
      var nextH = headerHeight();
      /* Only rebind when height actually changed. */
      if (observer && Math.abs(nextH - boundHeaderH) < 2) {
        var t = trigger || getTrigger();
        if (t) applyFromEntry({ boundingClientRect: t.getBoundingClientRect() });
        return;
      }
      lastShouldHave = null;
      bindObserver();
    }, 150);
  }

  function watchMenuState() {
    disconnectBodyObserver();
    if (typeof MutationObserver === 'undefined') return;

    /* Body only — never observe the header (class toggle must not re-enter apply). */
    bodyObserver = new MutationObserver(function (mutations) {
      if (destroyed || !mq.matches || !header) return;
      var bodyClassChanged = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target === document.body) {
          bodyClassChanged = true;
          break;
        }
      }
      if (!bodyClassChanged) return;

      if (isMenuOpen()) {
        setTransparent(false);
        return;
      }
      if (isFooterBehind()) {
        lastShouldHave = null;
        setTransparent(true);
        return;
      }
      if (trigger) {
        lastShouldHave = null;
        applyFromEntry({ boundingClientRect: trigger.getBoundingClientRect() });
      }
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function detachListeners() {
    if (!listenersAttached) return;
    listenersAttached = false;
    if (mq.removeEventListener) {
      mq.removeEventListener('change', onMqChange);
    } else if (mq.removeListener) {
      mq.removeListener(onMqChange);
    }
    window.removeEventListener('resize', onResize);
    window.removeEventListener('orientationchange', onResize);
    document.removeEventListener('shopify:section:load', onSectionLoad);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
  }

  function destroy() {
    destroyed = true;
    clearTimeout(resizeTimer);
    disconnectObserver();
    disconnectBodyObserver();
    detachListeners();
  }

  function onSectionLoad() {
    if (destroyed) return;
    header = getHeader();
    trigger = getTrigger();
    if (!header || !trigger) return;
    startedTransparent =
      header.classList.contains(TRANSPARENT) || header.getAttribute('data-transparent') === 'true';
    lastShouldHave = null;
    bindCount = Math.min(bindCount, 5);
    bindObserver();
    watchMenuState();
  }

  function onSectionUnload() {
    disconnectObserver();
    disconnectBodyObserver();
  }

  function init() {
    if (destroyed) return;
    header = getHeader();
    trigger = getTrigger();
    if (!header || !trigger) return;

    startedTransparent =
      header.classList.contains(TRANSPARENT) || header.getAttribute('data-transparent') === 'true';

    bindObserver();
    watchMenuState();

    if (!listenersAttached) {
      listenersAttached = true;
      if (mq.addEventListener) {
        mq.addEventListener('change', onMqChange);
      } else if (mq.addListener) {
        mq.addListener(onMqChange);
      }
      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('orientationchange', onResize);
      document.addEventListener('shopify:section:load', onSectionLoad);
      document.addEventListener('shopify:section:unload', onSectionUnload);
    }
  }

  window.__amArticleHeader = { destroy: destroy, rebind: bindObserver };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
